// Pricing configuration object for scalable model pricing
export const pricingConfig = {
	'en-AU': {
		Dolphin: {
			// 'X 40 PLUS': {
			// 	originalPrice: '$3,399.00',
			// },
			// 'X 30': {
			// 	originalPrice: '$2,699.00',
			// },
			// 'X 25': {
			// 	originalPrice: '$2,199.00',
			// },
			// 'Skimmi 300': {
			// 	originalPrice: '$949.00',
			// },
			// 'M 700': {
			// 	originalPrice: '$3,999.00',
			// },
			// 'S 50': {
			// 	originalPrice: '$1,049.00',
			// },
			// 'Liberty 400 Bundle': {
			// 	originalPrice: '$3,205.00',
			// },
			// 'Liberty 400': {
			// 	originalPrice: '$2,699.00',
			// },
			// 'S 400': {
			// 	originalPrice: '$3,399.00',
			// },
			// 'S 250': {
			// 	originalPrice: '$2,699.00',
			// },
			// 'S 150': {
			// 	originalPrice: '$2,099.00',
			// },
			// 'S 100': {
			// 	originalPrice: '$1,599.00',
			// },
			// 'M 700': {
			// 	originalPrice: '$3,999.00',
			// },
		},
		Niya: {
			'Niya Sonar F3': {
				originalPrice: '$1,199.00',
			},
			// 'Niya Eclipse 35': {
			// 	originalPrice: '$1,199.00',
			// },
		},
	},
}

// Helper function to get pricing info for a model
export const getPricingInfo = (locale, brand, model) => {
	return pricingConfig[locale]?.[brand]?.[model] || null
}